import { defineMessages } from 'react-intl';

const apnDeprecationUXMessages = defineMessages({
  alertContent: {
    id: 'apnDeprecationUXMessages.alertContent',
    defaultMessage:
      'Starting January 29, 2026, the APN sign-in option will be removed. After this date, please use your AWS Builder ID with the same email to sign in. All your training history from APN will be available under your AWS Builder ID.',
    decription: 'alert content for APN deprecation',
  },
});

export default apnDeprecationUXMessages;
